module.exports = __webpack_public_path__ + "img/vipIcon.191d1fcf.png";